import Highway from '@dogstudio/highway';

import HeroSlider from '../components/hero-slider/hero-slider';
import Carousel from '../components/carousel/carousel';
import ContactForm from '../components/contact/contact';
import Counter from '../components/counter/counter';
import MapHome from '../components/map/map-home';
import Store from '../components/store/store';

let heroSlider = null;
let counter = null;
let store = null;
let contactForm = null;
let carousels = [];

class PageRenderer extends Highway.Renderer {
  onEnter() {
    const view = this.properties.view;
    const logoEl = document.querySelector('.js-logo');
    const contentEl = document.querySelector('.js-content');
    const mapAsideEl = document.querySelector('.js-map-aside');
    const carouselEls = view.querySelectorAll('.js-carousel');

    if (view.querySelector('.js-hero-slider')) {
      heroSlider = new HeroSlider();
      heroSlider.init();
    }

    if (view.querySelector('.js-counter')) {
      counter = new Counter();
      counter.init();
    }

    if (view.querySelector('.js-store')) {
      store = new Store();
      store.init();
    }

    if (view.querySelector('.js-contact')) {
      contactForm = new ContactForm();
      contactForm.init();
    }

    if (carouselEls.length > 0) {
      [...carouselEls].forEach((el, index) => {
        const carousel = new Carousel(index);
        carousel.init();
        carousels.push(carousel);
      });
    }

    logoEl.classList = view.getAttribute('data-logo-class');
    contentEl.classList = view.getAttribute('data-content-class');
    mapAsideEl.classList = view.getAttribute('data-map-aside-class');

    if (view.querySelector('.js-map-home')) {
      const mapHome = new MapHome();
      mapHome.initMapHome();
    }
  }

  onLeave() {
    const view = this.properties.view;

    if (view.querySelector('.js-hero-slider')) heroSlider.destroy();
    if (view.querySelector('.js-counter')) counter = null;
    if (view.querySelector('.js-store')) store.destroy();
    if (view.querySelector('.js-contact')) contactForm.destroy();

    if (carousels.length > 0) {
      [...carousels].forEach((carousel) => carousel.destroy());
    }
  }
}

export default PageRenderer;
